import "./Articles.css";
import CardColorBlock from "../../components/cards/CardColorBlock/CardColorBlock";
import HighlightText from "../../components/texts/HighlightText/HighlightText";
import Title from "../../components/common/Title/Title";
import SEO from "../../components/common/SEO/SEO";
import ArticleCard from "../../components/cards/ArticleCard/ArticleCard";
import { useTranslation } from "react-i18next";

const articleJsonLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Articles",
  "description": "Read our articles and learn more about real-world industrial innovation.",
  "url": "https://www.aivhy.com/articles",
  "publisher": {
    "@type": "Organization",
    "name": "AIVHY",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.aivhy.com/images/logos/LOGO_AIVHY.webp"
    }
  }
};

export default function Articles() {
  const { t } = useTranslation(['articles']);

  const seo = t('seo', { returnObjects: true }) || {};
  const hero = t('hero', { returnObjects: true }) || {};
  const intro = t('intro', { returnObjects: true }) || {};
  const cards = t('cards', { returnObjects: true }) || {};

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        url="https://www.aivhy.com/articles"
        image="https://www.aivhy.com/images/logos/LOGO_AIVHY.webp"
        jsonLd={articleJsonLd}
      />
      <div className="main-container">
          <main className="head-content">
              <div className="column-content-container height-container">
                  <Title text={hero.title} size={["4rem", "3rem", "2rem"]} level="h1" />
                  <HighlightText text={hero.tagline} size={["1.4rem", "1.2rem", "1rem"]} padding={["50px", "30px 24px", "20px"]} fontWeight="500" alignItems="flex-start"/>
                  <p className="paragraph-content">{intro.paragraph}</p>
              </div>
              <div className="cards-container">
                  <CardColorBlock iconClassName="fas fa-globe-africa" iconStyle={{ fontSize: "70px", color: "white" }} color={"var(--color-blue)"} title={cards?.realWorld?.title} text={cards?.realWorld?.text} />
                  <CardColorBlock iconClassName="fas fa-balance-scale" iconStyle={{ fontSize: "70px", color: "white" }} color={"var(--color-blue)"} title={cards?.realistic?.title} text={cards?.realistic?.text} />
                  <CardColorBlock iconClassName="fas fa-share-alt" iconStyle={{ fontSize: "70px", color: "white" }} color={"var(--color-orange)"} title={cards?.share?.title} text={cards?.share?.text} />
              </div>
          </main>
          <div className="page-content-container">
            <div className="article-cards-row">
              <ArticleCard
                imageSrc="/images/industries/heavy_industry.webp"
                title="Real-World Industry 4.0"
                description="Industry 4.0, an exciting future of digitalization, integration, and auto(no)mation. A future where organizations gain significant competitive advantage or fall behind. But what is Industry 4.0 exactly and what does it look like in the real world. Which challenges are there to overcome and how to do this?

This article provides an understanding in real-world Industry 4.0, lists achievable examples, and discusses the challenges that one most likely will encounter during the transformation. And finally, the article will introduce a comprehensive approach to the real-world Industry 4.0 transformation."
                link="/articles/real-world-industry-4-0"
                readMore={cards?.read_more}
              />
              <ArticleCard
                imageSrc="/images/banners/industry_4-0.webp"
                title="A comprehensive guide to Real-World Industry 4.0"
                description="Industry 4.0 holds an exciting future. A future that poses entirely new sources of business value and revenue. A disruptive transformation where organizations enter the 4th industrial revolution and leave their competitors behind through digitalization, integration, auto(no)mation, and insight.

Very exciting and crucial indeed, but how do real-world businesses with real-world budgets, real-world limitations, and perhaps operational legacy systems take part in this disruptive transformation?

This guide introduces a comprehensive real-world approach to lasting Industry 4.0. It enables real-world businesses to transform their organization with small value-generating steps, to a future of lasting uniform Industry 4.0."
                link="/articles/guide-to-real-world-industry-4-0"
                readMore={cards?.read_more}
              />
            </div>
            <div className="article-cards-row">
              <ArticleCard
                imageSrc="/images/industries/chain_machine.webp"
                title="What is Operational Technology (OT)?"
                description="Operational Technology (OT) is hardware with a digital or electronical core or software, that interacts with the physical world. This interaction includes sensing, actuating, direct monitoring and direct control of physical systems and processes."
                link="/articles/what-is-operational-technology"
                readMore={cards?.read_more}
              />
              <ArticleCard
                imageSrc="/images/industries/machine.webp"
                title="OT Cyber Security is different"
                description="Cybercrime could be a highly lucrative activity. Information could be stolen and sold, operations could be disrupted as paid criminal service or an entire company could be taken hostage for ransom. As soon as a company has value, it becomes a potential target for Cybercrime.

Recent development in digitalization and Industry 4.0 likely render OT environments not only defenseless against Cybercrime, but could even create a hard-to-close backdoor into your digital organization! IT Cyber Security applied within the OT environment will proof to be a poor fit. This is why OT Cyber Security must be approached correctly and prioritized at C-level."
                link="/articles/ot-cyber-security"
                readMore={cards?.read_more}
              />
            </div>
          </div>
      </div>
    </>
  );
}